<template>
	<div class="section-help padding-top-70 padding-bottom-70">
		<section-title component-class="title-white">
			<h2>
				<span class="fw-400">{{ $t('Section.HelpContainerSentence1') }}</span>
				{{ $t('Section.HelpContainerSentence2') }}?
			</h2>
			<p v-html="$t('Section.HelpContainerSentence3', ['/faq-utente', '/contatti'])"></p>
		</section-title>
	</div>
</template>

<script>
import SectionTitle from '@/components/partials/SectionTitle'

export default {
	name: 'HelpContainer',
	components: {
		SectionTitle,
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/HelpContainer.vue